'use client'
import React, { useContext, useEffect, useState } from 'react';
import { forwardRef } from '@chakra-ui/system';
import { Select } from 'chakra-react-select';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import { PersonaContext } from '../../lib/personaContext';
import { PersonaPageContext } from '../lib/personaPageContext';
import useTranslation from '../../../lib/i18n/useTranslation';
const MoveExperienceInPersonaToGroupForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    personaId,
  } = useContext(PersonaContext);
  const {
    experienceList,
    experienceGroupList,
    group
  } = useContext(PersonaPageContext);
  const {
    experienceId,
    hideSave,
    onSubmitted,
    onSubmitting,
    onValidityChange
  } = props;
  const {
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting, isValid }
  } = useForm();
  const experienceApi = useExperienceApi();
  const [groupOptionsList, setGroupOptionsList] = useState(null);
  const [experience, setExperience] = useState(null);
  const onSubmit = async (data) => {
    try {
      if (onSubmitting) {
        onSubmitting();
      }
      const groupId = data.group.value
      await experienceApi.moveExperienceToGroupInPersona(
        personaId,
        experienceId,
        groupId
      );
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {

    if (experienceGroupList && experienceId) {
      const experienceFiltered = experienceList.filter(listItem => {
        return listItem.experience?.id === experienceId
      })
      const newExperience = experienceFiltered[0]
      
      if (newExperience) {

        const groupOptionListInGroup = experienceGroupList
          .filter(eg => {
            const condition1 = eg.group.id !== newExperience.group_id
            const condition2 = eg.group_id === group?.id
            return condition1 && condition2
          })
          .map(eg => ({ label: eg.group.name, value: eg.group.id }))
        
        const otherGroupsOptionList = experienceGroupList
          .filter(eg => {
            const condition1 = eg.group.id !== newExperience.group_id
            const condition2 = eg.group_id !== group?.id
            return condition1 && condition2
          })
          .map(eg => ({ label: eg.group.name, value: eg.group.id }))
        
        const finalOptions = [{
          label: "In this group",
          options: groupOptionListInGroup,
        },{
          label: "Other",
          options: otherGroupsOptionList
        },{
          label: "Root",
          options: [{ label: "Root", value: null }]
        }]
        
        setExperience(newExperience);
        setGroupOptionsList(finalOptions);
      } else {
        setExperience(null);
        
        const allGroups = experienceGroupList.map(eg => ({ 
          label: eg.group.name, 
          value: eg.group.id 
        }))
        
        const finalOptions = [{
          label: "Available Groups",
          options: allGroups,
        },{
          label: "Root",
          options: [{ label: "Root", value: null }]
        }]
        
        setGroupOptionsList(finalOptions);
      }
    }
  }, [experienceGroupList, experienceId]);
  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <Controller
          control={control}
          name="group"
          rules={{ required: "Please select a group" }}
          render={({
            field: { onBlur, value, onChange },
          }) => (
            <FormControl isInvalid={errors && errors.group}>
              <FormLabel>{t('group.selectGroup')}</FormLabel>
              <Select
                options={groupOptionsList}
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              />
              <FormErrorMessage>{errors && errors.group}</FormErrorMessage>
            </FormControl>
          )}
        />
        <Button
          style={{
            display: hideSave ? 'none' : 'inherit',
          }}
          ref={ref}
          isLoading={isSubmitting}
          disabled={!isValid}
          type='submit'
          my={2}
        >Save</Button>
      </form>
    </>
  );
});
export default MoveExperienceInPersonaToGroupForm;
